export const coverJourneyPathSegment = '/cover-journey'

export const coverJourneyStepsUrls = {
  aboutYou: `${coverJourneyPathSegment}/about-you/`,
  aboutYourHome: `${coverJourneyPathSegment}/about-your-home/`,
  aboutBoilerInfo: `${coverJourneyPathSegment}/about-your-current-boiler-information/`,
  aboutBoilerBrand: `${coverJourneyPathSegment}/about-your-current-boiler-brand/`,
  yourQuote: `${coverJourneyPathSegment}/your-quote/`,
  coverPolicyDetails: `${coverJourneyPathSegment}/cover-policy-application-details/`,
  coverPolicyBankAccount: `${coverJourneyPathSegment}/cover-policy-application-bank-account/`,
  coverPolicyConfirmation: `${coverJourneyPathSegment}/application-confirmation/`,
  coverApplicationSubmitted: `${coverJourneyPathSegment}/cover-application-submitted/`,
}

// Actually it's a List
export const coverJourneyRoutesMap = [
  coverJourneyStepsUrls.aboutYou,
  coverJourneyStepsUrls.aboutYourHome,
  coverJourneyStepsUrls.aboutBoilerInfo,
  coverJourneyStepsUrls.aboutBoilerBrand,
  coverJourneyStepsUrls.yourQuote,
  coverJourneyStepsUrls.coverPolicyDetails,
  coverJourneyStepsUrls.coverPolicyBankAccount,
  coverJourneyStepsUrls.coverPolicyConfirmation,
  coverJourneyStepsUrls.coverApplicationSubmitted,
]

// setup sales funnel routes
export const salesFunnelJourneyStepsUrls = {
  yourPlanQuote: `${coverJourneyPathSegment}/your-plan-quote/`,
  yourDetails: `${coverJourneyPathSegment}/your-details/`,
  yourApplicationSubmitted: `${coverJourneyPathSegment}/application-submitted/`,
}

export const salesFunnelJourneyRoutesMap = [
  salesFunnelJourneyStepsUrls.yourPlanQuote,
  salesFunnelJourneyStepsUrls.yourDetails,
  salesFunnelJourneyStepsUrls.yourApplicationSubmitted,
]
